(function () {
  function getDrawer() {
    return document.getElementById('lx-cart-drawer');
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lx-cart-drawer-lock');
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lx-cart-drawer-lock');
  }

  function toggleDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    if (drawer.classList.contains('is-open')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  }

  function swapSection(id, html) {
    var current = document.getElementById('shopify-section-' + id);
    if (!current) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var replacement = doc.getElementById('shopify-section-' + id);
    if (replacement) current.replaceWith(replacement);
  }

  function refreshCart() {
    var url = window.location.pathname + '?sections=header,cart-drawer';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.header) swapSection('header', data.header);
        if (data['cart-drawer']) swapSection('cart-drawer', data['cart-drawer']);
      });
  }

  function addToCart(form) {
    var drawer = getDrawer();
    var addUrl = drawer ? drawer.dataset.cartAddUrl : '/cart/add.js';
    var formData = new FormData(form);

    return fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function () {
        return refreshCart();
      })
      .then(function () {
        openDrawer();
      })
      .catch(function (err) {
        var message = (err && err.description) || 'Could not add this item to your cart.';
        window.alert(message);
      });
  }

  function changeLine(key, quantity) {
    var drawer = getDrawer();
    var changeUrl = drawer ? drawer.dataset.cartChangeUrl : '/cart/change.js';

    return fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Number(quantity) }),
    })
      .then(function () {
        return refreshCart();
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-toggle]')) {
      e.preventDefault();
      toggleDrawer();
      return;
    }
    if (e.target.closest('[data-cart-drawer-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    if (e.target.closest('[data-cart-drawer-overlay]')) {
      closeDrawer();
      return;
    }
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      changeLine(removeBtn.dataset.cartRemove, 0);
    }
  });

  document.addEventListener('change', function (e) {
    var qtyInput = e.target.closest('[data-cart-qty]');
    if (qtyInput) changeLine(qtyInput.dataset.cartQty, qtyInput.value);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });
})();
